import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { MediaLibraryShareRequestLinkTypeEnum, MediaRootPermissionFromJSON, MediaRootPermissionToJSON } from 'elements-sdk'
import { TaskParamsContext } from 'tasks/taskParams'
import type { ShareArgs as Args } from 'tasks/taskParams/generatedInputDefs'

import { SharingParameters, SharingParametersComponent } from './sharingParameters.component'

@Component({
  selector: 'media-share-task-params',
  templateUrl: './mediaShareTaskParams.component.html',
  imports: [
    FormsModule,
    SharingParametersComponent,
  ],
})
export class MediaShareTaskParamsComponent {
  parameters?: SharingParameters

  constructor (
    public readonly ctx: TaskParamsContext<Args>,
  ) { }

  async ngOnInit () {
    this.parameters = {
      permissions: MediaRootPermissionFromJSON(this.ctx.args.permissions ?? { allow_read: true }),
      expiry: new Date(Date.now() + (this.ctx.args.expiry_days ?? 7) * 3600 * 24 * 1000),
      viewLimit: this.ctx.args.view_limit ?? null,
      linkType: (this.ctx.args.link_type ?? null) as MediaLibraryShareRequestLinkTypeEnum | null,
      password: this.ctx.args.password ?? null,
    }
  }

  onParametersChange () {
    if (!this.parameters) {
      return
    }
    this.ctx.args.permissions
      = Object.fromEntries(
        Object.entries(MediaRootPermissionToJSON(this.parameters.permissions as any))
          .filter(([_, v]) => v)
          .map(([k]) => [k, true]),
      )
    this.ctx.args.expiry_days = Math.round((this.parameters.expiry.getTime() - Date.now()) / 1000 / 3600 / 24)
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    this.ctx.args.view_limit = this.parameters.viewLimit || null // can be 0
    this.ctx.args.link_type = this.parameters.linkType
    this.ctx.args.password = this.parameters.password
  }

  get shouldShowLinkType (): boolean {
    return this.ctx.args.input.length <= 1
  }
}
